import { Text, GreyGrey90, Primary13Regular } from '@sequencehq/core-components'

export const SnowflakeIntegrationDetail = () => {
  return (
    <Text {...Primary13Regular} color={GreyGrey90} lineHeight="18px">
      Export all your Sequence data to a wide range of destinations, such as
      data warehouses and Google Sheets. Use data exports to connect your
      billing and invoicing data to other internal sources, leverage your
      existing data tools for analysis and reports, and build custom
      applications.
    </Text>
  )
}
